export const SLOTS_NEW_PER_YEAR = {
  1: 3,
  2: 4,
  3: 5
};

export const SLOTS_CUMULATIVE_BY_YEAR = {
  1: 3,
  2: 7,
  3: 12
};
